import { render, staticRenderFns } from "./VideoWorkbench.vue?vue&type=template&id=15462451&scoped=true"
import script from "./VideoWorkbench.vue?vue&type=script&lang=js"
export * from "./VideoWorkbench.vue?vue&type=script&lang=js"
import style0 from "./VideoWorkbench.vue?vue&type=style&index=0&id=15462451&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15462451",
  null
  
)

export default component.exports